import { useEffect, useState } from "react";
import { base44 } from "@/api/base44Client";

// Texto por defecto del pie de página (se usa si el admin aún no ha guardado uno).
export const DEFAULT_FOOTER_TEXT =
  "©2022-2026 BHGC NEXUS LOGÍSTICA · TODOS LOS DERECHOS RESERVADOS<br>BHGC NEXUS LOGISTICS – BHGCNEXUSLOGISTICS.COM™ · INTEGRADO A EL CERRITO DE TABASCO SC DE RL DE CV · DESARROLLADO POR IMPRENTA LOS ABUELOS, MARKETING NIVELPAUTA INC.";

export const DEFAULT_COPYRIGHT = {
  title: "BHGC Nexus Logistics",
  copyright_line: "© 2022 - 2026 BHGC Nexus Logistics",
  footer_text: DEFAULT_FOOTER_TEXT,
  body: "",
  version: "",
  who_we_are: "",
  mision: "",
  vision: "",
  valores: "",
};

// Caché a nivel de módulo: todos los componentes montados (footer del landing,
// layout de auth, tienda, páginas públicas) comparten una sola petición y el
// mismo registro en memoria. La suscripción a CopyrightContent invalida la
// caché cuando el admin guarda, así el pie de página se actualiza en vivo en
// todas las superficies abiertas sin recargar.
let _cache = null;
let _inflight = null;

export function useCopyrightContent() {
  const [content, setContent] = useState(() => _cache || DEFAULT_COPYRIGHT);
  const [loading, setLoading] = useState(() => !_cache);

  useEffect(() => {
    let active = true;
    const fetchIt = async () => {
      if (_cache) { setContent(_cache); setLoading(false); return; }
      if (!_inflight) {
        _inflight = base44.entities.CopyrightContent.list("-created_date", 1)
          .then((list) => { _cache = (list && list[0]) || null; _inflight = null; return _cache; })
          .catch(() => { _inflight = null; return null; });
      }
      const rec = await _inflight;
      if (!active) return;
      setContent(rec || DEFAULT_COPYRIGHT);
      setLoading(false);
    };
    fetchIt();
    // La suscripción realtime abre un WebSocket que falla y reintententa en la
    // landing pública (sin sesión), generando errores de consola. Solo se
    // suscribe cuando hay sesión: el live-update interesa al admin.
    let unsub = null;
    base44.auth.isAuthenticated().then((authed) => {
      if (!active || !authed) return;
      unsub = base44.entities.CopyrightContent.subscribe(() => {
        _cache = null;
        fetchIt();
      });
    }).catch(() => {});
    return () => { active = false; unsub && unsub(); };
  }, []);

  return { content, loading };
}